import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Logo } from './Logo';
import './Header.css';

interface HeaderProps {
  title: string;
  rightAction?: React.ReactNode;
  leftAction?: React.ReactNode;
  onBack?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ title, rightAction, leftAction, onBack }) => {
  const { t } = useTranslation();

  const hasTitleRow = !!(title && onBack);

  return (
    <header className={`header ${hasTitleRow ? 'header--title-row' : ''}`}>
      <div className="header__left">
        {onBack ? (
          <button 
            className="header__back-button neo-raised" 
            onClick={onBack}
            aria-label={t('common.back')}
          >
            <Icon name="chevron-left" size={24} color="var(--color-primary)" />
          </button>
        ) : leftAction}
      </div>
      <div className="header__title">
        {title && onBack ? (
          <span className="header__title-text">{title}</span>
        ) : (
          <>
            <Logo size={28} />
            <span className="header__brand">ALVEON</span>
          </>
        )}
      </div>
      <div className="header__right">{rightAction}</div>
    </header>
  );
};

